import { AgentKnowledgeKey, ColumnConfig } from '../model';

export const agentKnowledgeConfig: Record<AgentKnowledgeKey, ColumnConfig> = {
  docName: { name: 'Name', field: 'component' },
  status: { name: 'Status', field: 'component' },
  tags: { name: 'Tags', field: 'component' },
  actions: { name: 'Actions', field: 'component' },
};
